module.exports = __webpack_public_path__ + "img/pleisure_bodyimage06-7.d26afd6a.jpg";